import React, { lazy, Suspense } from 'react';
import { TpaSettingsProvider } from '@wix/tpa-settings/dist/src/contexts';

const Widget = lazy(() => import('./widget'));

const WidgetRoot = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return <div />;
  }

  return (
    <TpaSettingsProvider Wix={window.Wix}>
      <Suspense fallback={() => <div />}>
        <Widget />
      </Suspense>
    </TpaSettingsProvider>
  );
};

export default WidgetRoot;
